
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ffa306","d":"M30.011 8.44l17.514 8.408 4.326 18.892-12.12 15.15H20.29L8.172 35.74l4.326-18.892z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M20.822 14.392l16.046-.08L46.934 26.77 43.441 42.38 29.02 49.393l-14.492-6.869-3.648-15.577z"}}),_c('g',[_c('path',{attrs:{"fill":"#fff","d":"M36.976 23.315a1.17 1.17 0 01-.172.818l-1.356 2.097-4.458-3.446 1.356-2.093c.324-.492.952-.609 1.407-.26l2.812 2.176a1.1 1.1 0 01.41.708zm-6.254.915l4.268 3.24-6.281 9.496c-.135.199-.78 1.259-1.087 1.44l-3.251 1.698a.863.863 0 01-.94-.027A1.06 1.06 0 0123 39.072l.588-3.838c.024-.198.092-.387.2-.55.103-.158.528-.792.64-.968zM27.367 37.9a.138.138 0 00.081-.11.143.143 0 00-.051-.13l-1.637-1.23-1.559-1.18a.126.126 0 00-.122.003.144.144 0 00-.068.107l-.351 2.398 1.662 1.264 2.044-1.139zm5.497-9.698a.478.478 0 00-.692.13l-4.48 6.754a.556.556 0 00-.087.397.533.533 0 00.203.344.473.473 0 00.373.092.495.495 0 00.324-.217l4.48-6.773a.561.561 0 00-.12-.745z"}})])])
          )
        }
      }
    